import { render, staticRenderFns } from "./DashboardCardView.vue?vue&type=template&id=4da5f7b2"
import script from "./DashboardCardView.vue?vue&type=script&lang=ts"
export * from "./DashboardCardView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports